/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalBody,
  ModalFooter,
  Button,
  Image,
  Box,
  Center,
} from '@chakra-ui/react'
import { useState } from 'react'
import { Document, Page } from 'react-pdf'

interface FilePreviewProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  preview?: File | null | undefined
  previewUrl?: any | undefined
}

export const FilePreview = ({ isOpen, onClose, preview, previewUrl }: FilePreviewProps) => {
  const [numPages, setNumPages] = useState<number | null>(null)

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages)
  }

  return (
    <Modal blockScrollOnMount={false} size='4xl' isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Center>Preview</Center>
        </ModalHeader>
        <ModalBody>
          {preview?.type === 'application/pdf' ? (
            <Box
              mt='20px'
              position='relative'
              height='600px'
              overflowY='auto'
              bg='gray.100'
              p={4}
              borderRadius='md'
            >
              <Center>
                <Document
                  file={previewUrl || preview}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={<Center h='200px'>Loading PDF...</Center>}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Box key={`page_${index + 1}`} mb={4} boxShadow='md'>
                      <Page
                        pageNumber={index + 1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        width={800}
                      />
                    </Box>
                  ))}
                </Document>
              </Center>
            </Box>
          ) : (
            <Box>
              <Center>
                <Image my='20px' maxHeight='500px' rounded='lg' src={previewUrl} />
              </Center>
            </Box>
          )}
        </ModalBody>

        <Center>
          <Button
            width='125px'
            colorScheme='secondary'
            variant='solid'
            rounded={'full'}
            onClick={onClose}
          >
            Close
          </Button>
        </Center>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default FilePreview
